const candidateProfileMixin = {
    methods: {
        uploadAvatar( e ) {
            if ( e.target.files.length > 0 && e.target.files[0].type.indexOf( 'image/' ) > -1 )
                this.fileUploadService( e.target.files[0] )
                    .then( response => {
                        this.showAvatar = false;
                        this.candidate.photoUrl = response.data.data.storagePath;
                        this.candidate.photoId = response.data.data.id;
                        this.showAvatar = true;
                    
                    } );
            else
                this.snotifyError( 'fileFormatErrorMsg', '.png,.jpeg,...' );
        },
        
        notifyCandidate( appId, candidateId, type = 'testing_candidate_date' ) {
            return this.axios.post( this.$config.urls.candidate.notifyCandidate.url.replace( ':id', candidateId ), { type: type, appId: appId } )
                       .then( response => {
                           this.snotifySuccess( 'saveSuccessMsg' );
                       } )
        },
        getPercentageHtml( minPoint, totalScore, point ) {
            let p = this.getPercentage( totalScore, point );
        
            if ( p >= minPoint ) {
                return '<span class="text--success text--bold" >' + p + '%</span>';
            }
            else {
                return '<span class="text--danger text--bold" >' + p + '%</span>';
            }
        },
        getPercentage( totalScore, point ) {
            totalScore = parseFloat( totalScore );
            point = parseFloat( point );
        
            if ( totalScore <= 0 )
                return 0;
        
            let p = ( point * 100 ) / totalScore;
        
            return Number( ( p ).toFixed( 2 ) );
        },
    },
};

export default candidateProfileMixin;
